const mutations = {
    SET_LOGIN(state) {
        state.islogined = true
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js